import React from "react";
// import companylogo from "../logo.png"

export default function header(){
  return(
    <header id="header" class="fixed-top">
    <div class="container d-flex align-items-center justify-content-between">

      {/* <h1 class="logo"><a href="index.html">Cosmos</a></h1> */}
      <a href="index.html" class="logo"><img src="assets/img/logo.png" alt="" class="img-fluid"/></a>

      <nav id="navbar" class="navbar">
        <ul>
          <li><a class="nav-link scrollto active " href="#hero">Home</a></li>
          <li><a class="nav-link scrollto" href="#about">About Cosmos</a></li>
          {/* <li><a class="nav-link scrollto" href="#team">Team</a></li> */}
          {/* <li class="dropdown"><a href="#"><span>Domains</span> <i class="bi bi-chevron-down"></i></a>
            
          </li> */}
          <li><a class="nav-link scrollto active " href="https://cosmos-events.netlify.app/">Saavan</a></li>
          <li><a class="nav-link scrollto" href="#contact">Contact</a></li>
          <li><a class="getstarted scrollto" href="https://forms.gle/AQfn4jDr4b9T7jtb6">Join Now</a></li>
        </ul>
        <i class="bi bi-list mobile-nav-toggle"></i>
      </nav>
      {/* <!-- .navbar --> */}

    </div>
  </header>

  )
}